export const POSITION_ANNOUNCEMENT_READ_MORE_URL =
    "https://support.similarweb.com/hc/en-us/articles/39187562539805-Introducing-Position-the-new-metric-built-for-today-s-and-tomorrow-s-SERP";
